import styled from 'styled-components';
import QuestionCreate from '../QuestionCreate/QuestionCreate';

export const Container = styled.div``;

export const QuestionCreatee = styled(QuestionCreate)`
  /* margin: 2rem; */
`;
